import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PerformanceDashboardState {
  activeWidget: number;
  config: any[];
}

export const initialState: PerformanceDashboardState = {
  activeWidget: 1,
  config: [],
};

export const performanceDashboardSlice = createSlice({
  name: "performanceDashboard",
  initialState,
  reducers: {
    changeActiveWidget: (
      state: PerformanceDashboardState,
      action: PayloadAction<number>
    ) => {
      state.activeWidget = action.payload;
    },
    changeConfig: (
      state: PerformanceDashboardState,
      action: PayloadAction<any>
    ) => {
      state.config = action.payload;
    },
  },
});

export const { changeActiveWidget, changeConfig } =
  performanceDashboardSlice.actions;
